import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { EvaluationQueryView } from "./EvaluationQueryView";
import { EvaluationQueryViewStore } from "../../store/EvaluationQueryViewStore";
import { useStore } from "../../../../hooks";

export const EvaluationQueryViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/evaluationQuery/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new EvaluationQueryViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <EvaluationQueryView evaluationQueryViewStore={store} />
      </PageLayout>
    </div>
  );
});
